import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import type { Permission } from '@/types'
import AccessDenied from './AccessDenied'

interface Props {
  permission: Permission
  children: ReactNode
}

export default function PermissionRoute({ permission, children }: Props) {
  const { user, loading, hasPermission } = useAuth()

  if (loading) {
    return <div style={{ padding: 32, color: '#666' }}>Loading...</div>
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (!hasPermission(permission)) {
    return <AccessDenied />
  }

  return <>{children}</>
}
